"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Mediator = _interopRequireDefault(require("../withSidebar/Mediator"));
var _impact = _interopRequireDefault(require("../sessionDataEntry/impact.png"));
var _Settings = _interopRequireDefault(require("../withSidebar/Settings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
 * WARNING: DO NOT MOVE THIS FILE
 *
 * Its location is referenced directly from within an app because the search
 * for navigations occurs BEFORE the export in Root.js.
 *
 * To use this mediator in your app, import as follows:
 *
 * import outcomesDataEntry from 'cccisd-laravel-assignment/dist/components/navigations/outcomesDataEntry';
 */
var _default = exports["default"] = {
  handle: 'outcomesDataEntry',
  label: 'Outcomes Data Entry',
  mediatorComponent: _Mediator["default"],
  settingsComponent: _Settings["default"],
  thumbnail: _impact["default"]
};